import { PopupRenderer } from './PopupRenderer.js';
import {
  createIconWithDimensions,
  parseMarkerIconResolverResult,
} from '../IconSizeHelper.js';

export class JsonRenderer {
  constructor(url, options) {
    this.url = url;
    this.options = options;
    this.layer = L.featureGroup();
    this.popupRenderer = new PopupRenderer(options);
    this.markerCount = 0;
  }

  async draw(map) {
    this.layer.clearLayers();
    this.markerCount = 0;

    const res = await fetch(this.url);
    const data = await res.json();
    const filtered = data
      .filter((item) => this.options.filterFn(item, this.options.debug))
      .map(this.options.transformerFn);

    // Debug logging for data processing
    if (this.options.debug) {
      this.options.debug.log("JSON data processing:", data.length, "total items");
      this.options.debug.log("After filtering:", filtered.length, "items");
    }

    let markersCreated = 0;
    let markersSkipped = 0;

    const resolver = this.options.markerIconResolver;
    const staticIcon = resolver
      ? null
      : await createIconWithDimensions(
          this.options.markerIconUrl,
          this.options.markerShadowUrl,
          this.options.debug
        );

    for (const item of filtered) {
      const lat = parseFloat(item.acf?.latitude);
      const lng = parseFloat(item.acf?.longitude);
      if (!lat || !lng) {
        markersSkipped++;
        continue;
      }

      let icon = staticIcon;
      if (resolver) {
        const { iconUrl, shadowUrl } = parseMarkerIconResolverResult(
          resolver(item)
        );
        icon = await createIconWithDimensions(
          iconUrl,
          shadowUrl,
          this.options.debug
        );
      }

      const marker = L.marker([lat, lng], icon ? { icon } : {});

      // Use PopupRenderer to handle popup creation
      await this.popupRenderer.bindPopup(marker, item, this.panelRenderer);
      this.layer.addLayer(marker);
      markersCreated++;
    }

    // Debug logging for marker creation results
    if (this.options.debug) {
      this.options.debug.log("Markers created:", markersCreated, "skipped:", markersSkipped);
    }

    this.markerCount = markersCreated;
    this.layer.addTo(map);
  }

  getMarkerBounds() {
    if (!this.layer || this.layer.getLayers().length === 0) {
      return null;
    }
    return this.layer.getBounds();
  }

  getMarkerCount() {
    return this.markerCount;
  }

  async showItemInPanel(item) {
    // This will be called by the panel renderer
    if (this.panelRenderer) {
      await this.panelRenderer.showItemDetails(item);
    }
  }
}
